<div class="excel-export-container">
  <div class="export-info">
    <h4>序列 {{ trialSequenceNumber }} 數據導出</h4>
    <p class="participant-count">
      <span *ngIf="!isLoading">已完成參與者: {{ participantCount }} 位</span>
      <span *ngIf="isLoading && !isExporting">載入中...</span>
      <span *ngIf="isExporting"
        >正在導出 {{ totalParticipants }} 位參與者的數據...</span
      >
    </p>
  </div>

  <!-- Progress Bar Section -->
  <div class="progress-section" *ngIf="isExporting">
    <div class="progress-info">
      <span class="current-participant">{{ currentParticipant }}</span>
      <span class="progress-percentage">{{ exportProgress }}%</span>
    </div>
    <div class="progress-bar-container">
      <div class="progress-bar" [style.width.%]="exportProgress"></div>
    </div>
    <div class="progress-text">
      正在處理第 {{ currentParticipantIndex }} /
      {{ totalParticipants }} 位參與者
    </div>
  </div>

  <button
    class="excel-export-btn"
    (click)="exportExcel()"
    [disabled]="isLoading || participantCount === 0"
  >
    <span *ngIf="isExporting">導出中...</span>
    <span *ngIf="isLoading && !isExporting">載入中...</span>
    <span *ngIf="!isLoading">📊 導出為 CSV</span>
  </button>

  <p class="note" *ngIf="participantCount === 0 && !isLoading">
    尚無已完成的實驗數據可供導出
  </p>
</div>
